var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{staticClass:"ml-auto",attrs:{"flat":"","dense":"","hide-details":"","loading":_vm.loading,"disabled":_vm.loading,"label":_vm.label,"color":"info","input-value":_vm.status,"inset":""},on:{"change":_vm.onService}})}
var staticRenderFns = []

export { render, staticRenderFns }